import './App.css';
import { MainPage } from './Containers/Maincontainer';
import { AdminPage } from './Containers/Admincontainer';
import { BlogPage } from './Containers/BlogContainer';
import { ViewBlogPage } from './Containers/ViewContainer';
import { BlogEditor } from './Containers/BlogEditor';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Helmet from "react-helmet"



function App() {
  return (
    <>
    <Helmet>
    <title>Salwa Amer | استشارات نفسية اون لاين</title>
    </Helmet>
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/admin" element={<AdminPage  />} />
      <Route path="/admin/blogs" element={<BlogEditor />} />
      <Route path="/blogs" element={<BlogPage />} />
      <Route path="/viewblog/:id" element={<ViewBlogPage/>}/>
    </Routes>
  </BrowserRouter>
    </>
  
  );
}

export default App;
